'use client';

import { PageRow } from '@components/PageRow';
import { freddyTheme, useMediaQuery } from '@coolblue-development/freddy';
import { ApplicationFormBlock, FollowUpFlow, Status, Statuses } from '@sharedTypes';
import { useEffect, useState } from 'react';

import { Form } from './Form';

type Props = {
  block: ApplicationFormBlock;
  pageStatus: Status;
  followUpFlow: FollowUpFlow;
};

export const ApplicationForm = ({ block, pageStatus, followUpFlow }: Props) => {
  const matchesMediumBreakpoint = useMediaQuery(freddyTheme.breakpoint.minWidth('md'));
  const [isDesktop, setIsDesktop] = useState(false);
  const [withContainerStyles, setWithContainerStyles] = useState(true);

  useEffect(() => {
    setIsDesktop(matchesMediumBreakpoint || false);
  }, [matchesMediumBreakpoint]);

  if (pageStatus === Statuses.UNPUBLISHED) return null;

  return (
    <PageRow
      withContainer={withContainerStyles && isDesktop}
      backgroundColor={isDesktop && withContainerStyles ? undefined : 'base'}
    >
      <Form
        applicationForm={block}
        followUpFlow={followUpFlow}
        setWithContainerStyles={setWithContainerStyles}
      />
    </PageRow>
  );
};
